console.log('TFD Featured Products Loaded');

document.addEventListener('DOMContentLoaded', () => {

  /* ==========================================
     TABS
  ========================================== */

  const tabs = document.querySelectorAll('.tfd-fp-tab');
  const panels = document.querySelectorAll('.tfd-fp-panel');

  tabs.forEach(tab => {

    tab.addEventListener('click', () => {

      const target = tab.dataset.tab;

      tabs.forEach(t => t.classList.remove('active'));
      panels.forEach(panel => panel.classList.remove('active'));

      tab.classList.add('active');

      const activePanel = document.querySelector(
        `.tfd-fp-panel[data-panel="${target}"]`
      );

      if (activePanel) {
        activePanel.classList.add('active');
      }

    });

  });

  /* ==========================================
     SLIDERS
  ========================================== */

  const sliders = document.querySelectorAll('.tfd-fp-slider');

  sliders.forEach(slider => {

    const track = slider.querySelector('.tfd-fp-track');
    const prev = slider.querySelector('.tfd-fp-arrow.prev');
    const next = slider.querySelector('.tfd-fp-arrow.next');

    if (!track) return;

    const getScrollAmount = () => {

      const card = track.querySelector('.tfd-product-card');

      if (!card) return 320;

      const gap =
        parseInt(window.getComputedStyle(track).gap) || 24;

      return card.offsetWidth + gap;

    };

    if (next) {

      next.addEventListener('click', () => {

        track.scrollBy({
          left: getScrollAmount() * 2,
          behavior: 'smooth'
        });

      });

    }

    if (prev) {

      prev.addEventListener('click', () => {

        track.scrollBy({
          left: -(getScrollAmount() * 2),
          behavior: 'smooth'
        });

      });

    }

  });

  /* ==========================================
     DRAG SUPPORT
  ========================================== */

  document
    .querySelectorAll('.tfd-fp-track')
    .forEach(track => {

      let isDragging = false;
      let startX = 0;
      let scrollLeft = 0;

      track.addEventListener('mousedown', e => {

        isDragging = true;

        track.classList.add('dragging');

        startX = e.pageX;
        scrollLeft = track.scrollLeft;

      });

      track.addEventListener('mouseleave', () => {

        isDragging = false;
        track.classList.remove('dragging');

      });

      track.addEventListener('mouseup', () => {

        isDragging = false;
        track.classList.remove('dragging');

      });

      track.addEventListener('mousemove', e => {

        if (!isDragging) return;

        e.preventDefault();

        const walk = (e.pageX - startX) * 1.4;

        track.scrollLeft = scrollLeft - walk;

      });

      /* Touch */

      let touchStartX = 0;
      let touchScrollLeft = 0;

      track.addEventListener(
        'touchstart',
        e => {

          touchStartX = e.touches[0].pageX;
          touchScrollLeft = track.scrollLeft;

        },
        { passive: true }
      );

      track.addEventListener(
        'touchmove',
        e => {

          const walk =
            (e.touches[0].pageX - touchStartX) * 1.2;

          track.scrollLeft =
            touchScrollLeft - walk;

        },
        { passive: true }
      );

    });

  /* ==========================================
     ARROW VISIBILITY
  ========================================== */

  const updateArrows = slider => {

    const track =
      slider.querySelector('.tfd-fp-track');

    const prev =
      slider.querySelector('.tfd-fp-arrow.prev');

    const next =
      slider.querySelector('.tfd-fp-arrow.next');

    if (!track || !prev || !next) return;

    const maxScroll =
      track.scrollWidth - track.clientWidth;

    prev.disabled = track.scrollLeft <= 5;

    next.disabled = track.scrollLeft >= maxScroll - 5;

  };

  document
    .querySelectorAll('.tfd-fp-slider')
    .forEach(slider => {

      const track =
        slider.querySelector('.tfd-fp-track');

      if (!track) return;

      updateArrows(slider);

      track.addEventListener(
        'scroll',
        () => updateArrows(slider)
      );

      window.addEventListener(
        'resize',
        () => updateArrows(slider)
      );

    });

});